import { Icon } from '../ui/icons.js';
import { openParticleEditor } from './open.js';

/** "Open Particle Editor" button for the Inspector's Particle System card. */
export function OpenParticleEditorButton({ entityId }: { entityId: string }) {
  return (
    <button type="button" className="ghost small pe-open-button" onClick={() => openParticleEditor(entityId)} title="Edit this system in the Particle Editor panel (live preview, curves, playback)">
      <Icon name="particles" size={12} /> Open Particle Editor
    </button>
  );
}
